export default __webpack_public_path__ + "static/media/close.ffbaaa54.svg";